<template>
  <responsive-controller>
    <template #laptop>
      <application-header-mobile-template
        :merchant="merchant"
        :projects="availableProjects"
        :use-self-employed="isSelfEmployedActivated"
        :notifications-count="notificationsCount"
        @logout="handleLogout"
        @navigate="handleNavigate"
        @change-project="handleChangeProject"
        @create-project="handleCreateProject"
      ></application-header-mobile-template>
    </template>
    <template #default>
      <application-header-desktop-template
        :merchant="merchant"
        :projects="availableProjects"
        :use-self-employed="isSelfEmployedActivated"
        :notifications-count="notificationsCount"
        @logout="handleLogout"
        @navigate="handleNavigate"
        @change-project="handleChangeProject"
        @create-project="handleCreateProject"
      ></application-header-desktop-template>
    </template>
  </responsive-controller>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

import AuthService from '@/services/auth';
import MerchantService from 'services/merchant';

import ApplicationHeaderMobileTemplate from 'templates/header/mobile/ApplicationHeaderMobileTemplate';
import ApplicationHeaderDesktopTemplate from 'templates/header/desktop/ApplicationHeaderDesktopTemplate';

import { PARTNER_TYPE } from 'definitions/project';

export default {
  name: 'ApplicationHeader',
  components: {
    ApplicationHeaderMobileTemplate,
    ApplicationHeaderDesktopTemplate,
  },
  props: {
    merchant: {
      type: Object,
      required: true,
    },
  },
  computed: {
    availableProjects() {
      return this.merchant.projects.filter(project => {
        if (project.type === PARTNER_TYPE) {
          return project.transactionsBrowsingPermission;
        }

        return true;
      });
    },
    isSelfEmployedActivated() {
      return MerchantService.checkSelfEmployed(this.merchant);
    },
    notificationsCount() {
      if (this.SELF_EMPLOYED_NOTIFICATIONS_LOADING) {
        return 0;
      }

      return this.SELF_EMPLOYED_NOTIFICATIONS_UNREADED.length;
    },
    // TODO: @danealton избавить от геттера и принимать данные о уведомлениях по самозанятым в пропсах
    ...mapGetters([
      'SELF_EMPLOYED_NOTIFICATIONS_LOADING',
      'SELF_EMPLOYED_NOTIFICATIONS_UNREADED',
    ]),
  },
  methods: {
    isActiveRoute(route) {
      return route === this.$route.name;
    },
    handleNavigate() {
      if (this.isActiveRoute('projects')) {
        this.$router.push({ name: 'cabinet' }).catch(() => {});
        return;
      }

      this.$router.push({ name: 'projects' }).catch(() => {});
    },
    handleLogout() {
      AuthService.logout();

      // TODO: @danealton реализовать обработку события выхода для вызова мутации this.SET_THEME('obsidian');
      this.$emit('logout');
    },
    handleChangeProject(project) {
      // TODO: @danealton заменить вызов экшена на вызов сервиса ProjectService
      this.CHANGE_PROJECT({
        currency: project.currency,
        projectId: project.projectId,
        routeName: 'cabinet',
        link: project.link,
      });
    },
    handleCreateProject() {
      this.$router.push({ name: 'projectCreate' }).catch(() => {});
    },
    ...mapActions(['CHANGE_PROJECT']),
  },
};
</script>
